import { InternalLinkType } from './InternalLink';

export const AVAILABLE_INTERNAL_LINK: Record<string, InternalLinkType[]> = {
  TEL: [
    InternalLinkType.ARTICLE,
    InternalLinkType.PROGRAM,
    InternalLinkType.BROADCAST,
  ],
  CAP: [InternalLinkType.ARTICLE],
  VOI: [InternalLinkType.ARTICLE],
  GAL: [InternalLinkType.ARTICLE],
  TLS: [
    InternalLinkType.ARTICLE,
    InternalLinkType.PROGRAM,
    InternalLinkType.BROADCAST,
  ],
  TGC: [
    InternalLinkType.ARTICLE,
    InternalLinkType.PROGRAM,
    InternalLinkType.BROADCAST,
  ],
  TLA: [InternalLinkType.ARTICLE],
  BEA: [InternalLinkType.ARTICLE, InternalLinkType.PRODUCT],
  FAC: [InternalLinkType.ARTICLE, InternalLinkType.RECIPE],
  SHGFAC: [InternalLinkType.ARTICLE],
  CAC: [InternalLinkType.ARTICLE, InternalLinkType.RECIPE],
  GEO: [InternalLinkType.ARTICLE],
  FRGSL: [InternalLinkType.ARTICLE],
  FRGSD: [InternalLinkType.ARTICLE],
  FRGSG: [InternalLinkType.ARTICLE],
  FRGSS: [InternalLinkType.ARTICLE],
  FRGSV: [InternalLinkType.ARTICLE],
  FROMM: [InternalLinkType.ARTICLE],
  BRGTS: [InternalLinkType.ARTICLE],
  BROMM: [InternalLinkType.ARTICLE],
  DEGTS: [InternalLinkType.ARTICLE],
  DEOMM: [InternalLinkType.ARTICLE],
  ESGTS: [InternalLinkType.ARTICLE],
  ESOMM: [InternalLinkType.ARTICLE],
  ITGTS: [InternalLinkType.ARTICLE],
  ITOMM: [InternalLinkType.ARTICLE],
  UKGTS: [InternalLinkType.ARTICLE],
  UKOMM: [InternalLinkType.ARTICLE],
  NEO: [InternalLinkType.ARTICLE],
  BIN: [InternalLinkType.ARTICLE],
  TESTBRAND: [
    InternalLinkType.ARTICLE,
    InternalLinkType.PROGRAM,
    InternalLinkType.BROADCAST,
  ],
};
